/**
 * @generated SignedSource<<9cd9654d2f9c249abfb575db3a228e9e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type recentFormsListItem_on_RequestForm$data = {
  readonly descriptionHtml: string | null;
  readonly id: string;
  readonly name: string | null;
  readonly portalId: string | null;
  readonly portalName: string | null;
  readonly " $fragmentType": "recentFormsListItem_on_RequestForm";
};
export type recentFormsListItem_on_RequestForm$key = {
  readonly " $data"?: recentFormsListItem_on_RequestForm$data;
  readonly " $fragmentSpreads": FragmentRefs<"recentFormsListItem_on_RequestForm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "recentFormsListItem_on_RequestForm",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "descriptionHtml"
    },
    {
      "kind": "ScalarField",
      "name": "portalName"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "portalId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "HelpLayoutRequestForm"
};

(node as any).hash = "b5d8c7e23b6e2eb41dd1dea2dec19c82";

export default node;
